import { useEffect, useRef } from "react";
import { recordAdClick, recordAdImpression } from "../../functions/ads";
import "./style.css";

const API_URL = process.env.REACT_APP_API_URL !== undefined
  ? process.env.REACT_APP_API_URL
  : "http://localhost:8000";

function mediaSrc(url) {
  if (!url) return "";
  return url.startsWith("http") ? url : `${API_URL}${url}`;
}

export default function SponsoredAd({ ad, user }) {
  const cardRef = useRef(null);
  const recordedRef = useRef(false);

  useEffect(() => {
    const node = cardRef.current;
    if (!node || !ad?._id || !user?.token || recordedRef.current) return undefined;

    const observer = new IntersectionObserver(
      (entries) => {
        const entry = entries[0];
        if (entry?.isIntersecting && entry.intersectionRatio >= 0.5 && !recordedRef.current) {
          recordedRef.current = true;
          recordAdImpression(ad._id, user.token);
          observer.disconnect();
        }
      },
      { threshold: 0.5 }
    );

    observer.observe(node);
    return () => observer.disconnect();
  }, [ad?._id, user?.token]);

  const openDestination = async (event) => {
    event.preventDefault();
    event.stopPropagation();
    if (!ad?.destinationUrl) return;
    if (user?.token) {
      await recordAdClick(ad._id, user.token);
    }
    window.open(ad.destinationUrl, "_blank", "noopener,noreferrer");
  };

  if (!ad) return null;

  return (
    <article className="post sponsored_ad" ref={cardRef} aria-label={`Sponsored: ${ad.title}`}>
      <div className="post_header">
        <div className="post_header_left">
          <div className="sponsored_ad_avatar" aria-hidden="true">
            {ad.title?.charAt(0)?.toUpperCase() || "A"}
          </div>
          <div className="header_col">
            <div className="post_profile_name">
              {ad.title}
              <span className="sponsored_label">Sponsored</span>
            </div>
            <div className="post_profile_privacy_date">Promoted content</div>
          </div>
        </div>
      </div>

      {ad.description ? <div className="sponsored_ad_text">{ad.description}</div> : null}

      {ad.mediaUrl && (
        <button type="button" className="sponsored_ad_media" onClick={openDestination}>
          {ad.mediaType === "video" ? (
            <video
              src={mediaSrc(ad.mediaUrl)}
              controls
              muted
              playsInline
              preload="metadata"
            />
          ) : (
            <img src={mediaSrc(ad.mediaUrl)} alt={ad.title} />
          )}
        </button>
      )}

      <div className="sponsored_ad_footer">
        <a
          href={ad.destinationUrl}
          className="sponsored_ad_cta"
          onClick={openDestination}
          rel="noopener noreferrer"
        >
          {ad.ctaText || "Learn more"}
        </a>
      </div>
    </article>
  );
}
